export default __webpack_public_path__ + "static/media/terminal.d552e435.png";